import React, { useState } from 'react'
import { FaThumbsUp, FaComment, FaThumbtack } from 'react-icons/fa'

// canRemove/onRemove: card-level delete. canRemoveComment/onRemoveComment:
// same idea per comment. Both resolved by the caller (master moderates
// anything, an author can only take back their own card/comment).
// isMaster: pin toggling is the one thing that's strictly master-only.
const RetroCardItem = ({
  card,
  canRemove,
  onRemove,
  reacted,
  onToggleReact,
  onComment,
  isMaster,
  onTogglePin,
  canRemoveComment,
  onRemoveComment,
}) => {
  const [showComments, setShowComments] = useState(false)
  const [commentText, setCommentText] = useState('')

  const submitComment = () => {
    if (!commentText.trim()) return
    onComment(card, commentText)
    setCommentText('')
  }

  return (
    <div className={`retro-card${card.pinned ? ' pinned' : ''}`}>
      <div className="retro-card-top">
        <p className="retro-card-text">{card.text}</p>
        <div className="retro-card-top-buttons">
          {isMaster && (
            <button
              type="button"
              className={`retro-card-pin${card.pinned ? ' active' : ''}`}
              onClick={() => onTogglePin(card)}
              aria-label={card.pinned ? 'Desafixar cartão' : 'Fixar cartão'}
              title={card.pinned ? 'Desafixar' : 'Fixar'}
            >
              <FaThumbtack />
            </button>
          )}
          {canRemove && (
            <button
              type="button"
              className="retro-card-remove"
              onClick={() => onRemove(card)}
              aria-label="Excluir cartão"
            >
              ×
            </button>
          )}
        </div>
      </div>

      <div className="retro-card-actions">
        <button
          type="button"
          className={`retro-card-react${reacted ? ' active' : ''}`}
          onClick={() => onToggleReact(card)}
          aria-label={reacted ? 'Remover reação' : 'Reagir'}
        >
          <FaThumbsUp />
          {card.reactions > 0 && <span>{card.reactions}</span>}
        </button>
        <button
          type="button"
          className="retro-card-comment-toggle"
          onClick={() => setShowComments((current) => !current)}
          aria-label="Ver comentários"
        >
          <FaComment />
          {card.comments.length > 0 && <span>{card.comments.length}</span>}
        </button>
      </div>

      {showComments && (
        <div className="retro-card-comments">
          {card.comments.map((comment) => (
            <div className="retro-comment" key={comment.id}>
              <span className="retro-comment-text">{comment.text}</span>
              {canRemoveComment(comment) && (
                <button
                  type="button"
                  className="retro-comment-remove"
                  onClick={() => onRemoveComment(card, comment.id)}
                  aria-label="Excluir comentário"
                >
                  ×
                </button>
              )}
            </div>
          ))}
          <div className="retro-comment-form">
            <input
              type="text"
              value={commentText}
              onChange={(e) => setCommentText(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && submitComment()}
              placeholder="Comentar..."
              maxLength={200}
            />
            <button type="button" onClick={submitComment} disabled={!commentText.trim()}>
              +
            </button>
          </div>
        </div>
      )}
    </div>
  )
}

export default RetroCardItem
